module.exports = __webpack_public_path__ + "img/cf14e12.png";